import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { usePermissions } from '@shared/hooks';
export function PermissionGuard({ resource, role, fallback = null, children, }) {
    const { roles, resources, isLoaded } = usePermissions();
    if (!isLoaded)
        return null;
    const hasResource = resource ? resources.includes(resource) : true;
    const hasRole = role ? roles.includes(role) : true;
    return hasResource && hasRole ? _jsx(_Fragment, { children: children }) : _jsx(_Fragment, { children: fallback });
}
